import { AuthHelper } from '../../utils/auth_helper';
import { SellersGroupListingForm } from "../../components/emp/SellersGroupListingForm";

import React from "react";
import Grid from '@mui/material/Grid';


function SellersGroupListing() {

  return (
    <div>
      <AuthHelper/>
      <div className="tw-px-5 sm:tw-ml-20 tw-text-left">

          
          <Grid container direction="row" alignItems="center" justifyContent="" >

            <Grid container>
              <Grid item xs={12} sm={12}>
                <span className="tw-p-10 tw-text-3xl"><p>Sellers Group Listing</p></span>
              </Grid>
            </Grid>

            <SellersGroupListingForm />

          </Grid>
          
      </div>

    </div>
  );

}


export { SellersGroupListing };
